import { call, select, put, all } from "redux-saga/effects"
import { PROGRAM_MOVIEMAPPING_ITEMS } from "../../../constants/state"
import { reorderListItems } from "../../../functions/lists"
import actionTypes from '../../../actions/actionTypes'
import getData from "../../../functions/getData"
import FarreyFrac from "../../../classes/farreyFrac"

const pmMoviePkSelector = (state, pmMoviePk) => getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, pmMoviePk, 'pm'])


function* getOrderAttributeByIndex(index, orderSize, order, selector) {
    if(-1 === index) {
        return yield all([0,1])
    } else if(orderSize === index){
        return yield all([1,0])
    } else {
        const id = yield order.get(index).toString()
        const itemIndex = yield select(selector, id)
        return yield all(itemIndex.toJS())
    }
}

function* getFractalOrder(index, order, selector) {
    const orderSize = yield order.count()
    const orderPrev = yield call(getOrderAttributeByIndex,index - 1, orderSize, order, selector)
    const orderNext = yield call(getOrderAttributeByIndex, index + 1, orderSize, order, selector)
    const farreyFrac = yield new FarreyFrac(orderPrev, orderNext)

    return yield all(farreyFrac.order())
}

function* putOrderFractal(type, pk, index, order, selector) {
    const fractalOrder = yield call(getFractalOrder, index, order, selector)
    let itemPk = pk
    if(type === actionTypes.PMMOVIES_UPDATE_ITEM_ORDER) {
        itemPk =  yield select(pmMoviePkSelector, pk)
    }

    yield put({
        type: type,
        meta: {},
        payload: {
            pk: itemPk,
            order: fractalOrder,
        }
    })
}

function* putOrderList(type, order) {
    yield put({
        type: type,
        meta: {},
        payload: {
            itemsList: order
        }
    })
}

function* putOrderListAndFractal(itemId, newIndex, newOrder, actionTypeOrderList, actionTypeOrderFractal, orderFractalSelector) {
    yield call(putOrderList,actionTypeOrderList, newOrder)
    yield call(putOrderFractal, actionTypeOrderFractal, itemId, newIndex, newOrder, orderFractalSelector)

}

export function* reorderListAndFractal(oldIndex, newIndex, actionTypeOrderList, actionTypeOrderFractal, orderListSelector, orderFractalSelector) {
    const order = yield select(orderListSelector)
    const newOrder = yield call(reorderListItems, order, oldIndex, newIndex)
    const itemId = yield newOrder.get(newIndex)

    yield call(putOrderListAndFractal, itemId, newIndex, newOrder, actionTypeOrderList, actionTypeOrderFractal, orderFractalSelector)
}

export function* addItemToListAndFractal(itemId, actionTypeOrderList, actionTypeOrderFractal, orderListSelector, orderFractalSelector) {
    const oldOrder = yield select(orderListSelector)
    const newOrder = yield oldOrder.push(itemId)
    const newIndex = yield newOrder.size - 1

    yield call(putOrderListAndFractal, itemId, newIndex, newOrder, actionTypeOrderList, actionTypeOrderFractal, orderFractalSelector)
}